export const amConfig = {
	enabled: process.env.REACT_APP_ENABLE_AFFILIATE_TRACKING !== 'false',
}
